import { Component, ComponentFactory, ElementRef, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ThemeService } from '@core/services/theme/theme.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app-root.component.html',
  styleUrls: ['./app-root.component.scss'],
})
export class AppRootComponent implements OnInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private element: ElementRef,
    private vcr: ViewContainerRef,
    private themeService: ThemeService
  ) { }

  ngOnInit(): void {
    this.subscribeToRouterEvents();
    this.subscribeToTheme();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private subscribeToTheme() {
    this.themeService.currentTheme
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (themeComponentFactory: ComponentFactory<any>) => {
          this.vcr.createComponent(themeComponentFactory);
        },
      });
  }

  private subscribeToRouterEvents(): void {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe({
        next: () => this.element.nativeElement.scrollIntoView(),
      });
  }

}
